import React, { useState, useEffect, useContext, useRef } from "react";
import Swal from "sweetalert2";
import { UserContext } from "../../contexts/UserContext";
import userDefaultImage from "../../images/default-profile.png";
import ProjectDescription from "./ProjectDescription";
import ProjectStatus from "./ProjectStatus";
import ProjectSupporter from "./ProjectSupporter";
import errorRedIcon from "../../images/errorRedIcon.png";
import { Link, useNavigate } from "react-router-dom";
import LoadingIcon from "../../images/Loading_icon.gif";
import { UrlContext } from "../../contexts/UrlContext";

export default function POSingleProject({ project, users, filtering }) {
  const [projectOwnerImage, setProjectOwnerImage] = useState(userDefaultImage);
  const [showProjectRow, setShowProjectRow] = useState(!filtering);
  // const [date, setDate] = useState('')
  // const [time, setTime] = useState('')
  const adminUser = useContext(UserContext);
  const { API_URL } = useContext(UrlContext);
  const [showDeleteBtn, setShowDeleteBtn] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);
  const [loadingPopup, setLoadingPopup] = useState(false);

  const descriptionButtonRef = useRef();
  const projSupporterRef = useRef();
  const projStatusRef = useRef();
  const projDeleteRef = useRef();
  const projExCall = useRef();
  const accountDetailsRef = useRef();
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      setShowProjectRow(true);
    }, 100);
  }, []);

  useEffect(() => {
    const ownerName = project.owner_name;
    const selectedUser = users.find((user) => {
      if (ownerName && ownerName.includes(" ")) {
        const ownerNameList = ownerName.split(" ");
        const username = user.username;
        const fullname = user.fullname;

        for (let i = 0; i < ownerNameList.length; i++) {
          if (
            fullname.includes(ownerNameList[i]) ||
            username.includes(ownerNameList[i])
          ) {
            return true;
          }
        }
      }
      return false;
    });
    if (selectedUser) {
      if (selectedUser.profilePicture) {
        setProjectOwnerImage(selectedUser.profilePicture);
      } else {
        setProjectOwnerImage(userDefaultImage);
      }
    } else {
      setProjectOwnerImage(userDefaultImage);
    }
  }, [project.owner_name, users]);

  // useEffect(() => {
  //    if (project.date_created) {
  //       const timeString = project.date_created.split(' ')[4];
  //       const [hours, minutes, seconds] = timeString.split(':');
  //       const formattedTime = `${hours}:${minutes}`;
  //       setTime(formattedTime);
  //    }
  // }, [project.date_created]);

  const handleDelete = () => {
    setDeletePopup(false);
    setLoadingPopup(true);
    const listID = project.id;
    const projectData = {
      listID,
    };
    const ephToken = localStorage.getItem("eph-token");
    const token = JSON.parse(ephToken).value;

    fetch(`${API_URL}delete-list`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(projectData),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoadingPopup(false);
        if (data.status === "success") {
          Swal.fire({
            title: "Success!",
            text: data.message,
            icon: "success",
            timer: 1500,
            showConfirmButton: false,
          });
          setShowProjectRow(false);
        } else {
          Swal.fire({
            title: "Error",
            text: data.message,
            icon: "error",
            timer: 1500,
            showConfirmButton: false,
          });
        }
      })
      .catch((err) => {
        setLoadingPopup(false);
        Swal.fire({
          title: "Error!",
          text: "Something went wrong!",
          icon: "error",
          timer: 1500,
        });
      });
  };

  const goProjectDetails = (e) => {
    if (
      descriptionButtonRef.current &&
      descriptionButtonRef.current.contains(e.target)
    )
      return;
    if (projSupporterRef.current && projSupporterRef.current.contains(e.target))
      return;
    if (projStatusRef.current && projStatusRef.current.contains(e.target))
      return;
    if (projDeleteRef.current && projDeleteRef.current.contains(e.target))
      return;
    if (projExCall.current && projExCall.current.contains(e.target)) return;
    if (
      accountDetailsRef.current &&
      accountDetailsRef.current.contains(e.target)
    )
      return;
    navigate(`/app/ListDetails/${project.id}`);
  };

  return (
    <>
      {showProjectRow && (
        <div
          onClick={goProjectDetails}
          key={project.id}
          onMouseOver={() => setShowDeleteBtn(true)}
          onMouseLeave={() => setShowDeleteBtn(false)}
        >
          <div className="project-table-row">
            <div className="row-top-div">
              <ul className="list-unstyled form-inline">
                <li className="project-title-td">
                  <div className="tooltip-div-onhover">
                    <Link to={`/app/ListDetails/${project.id}`}>
                      <span className="project-name-tag">
                        {project.name.includes(" - ")
                          ? project.name.split(" - ")[1]
                          : project.name}
                      </span>
                    </Link>
                    <span className="tooltiptext-onhover">
                      {project?.description}
                    </span>
                  </div>
                  <div className="tooltip-div-po" ref={descriptionButtonRef}>
                    <ProjectDescription
                      project_desc={project?.description}
                      project_id={project?.id}
                    />
                  </div>

                  <div>
                    <p className="client-name-tag colored-span">
                      {project.owner_name}
                    </p>
                  </div>
                </li>

                <li className="po-con-exp-li" ref={projExCall}>
                  <span className="po-con-exp-tag">
                    {project.cons_exp === "exp" ? (
                      <>
                        <i className="fa-solid fa-phone-volume"></i>
                        <span>Expert Call</span>
                      </>
                    ) : null}
                  </span>
                </li>

                <li className="zohoId-td" style={{ width: "45%" }}>
                  <span className="zohoId-tag">{project.zoho_id}</span>
                </li>
                <li
                  className="project-participation-icons-td"
                  style={{ width: "5%" }}
                >
                  <div className="all-participation-div">
                    <span>
                      <div className="total-experts" title="Added consultants">
                        <i className="fa-solid fa-users" />
                        <span>{project.total_expert_inside}</span>
                      </div>
                    </span>
                    {/* <span>
                           <div className="interested-experts" title="Interested consultants">
                              <i className="fa-solid fa-user" />
                              <span>{project.total_interested_expert}</span>
                           </div>
                        </span>
                        <span>
                           <div className="participated-experts" title="Participated consultants">
                              <i className="fa-regular fa-user third-icon" />
                              <i className="fa-solid fa-check icon-absolute" />
                              <span>{project.total_participated_expert}</span>
                           </div>
                        </span> */}
                  </div>
                </li>
                {/* <li className="gap1-td"></li> */}
                {/* <li className="status-bar-td" ref={projStatusRef}>
                     <ProjectStatus project_status={project.status} project_id={project.id} />
                  </li> */}
              </ul>
            </div>
            <div className="row-bottom-div" style={{ position: "relative" }}>
              <div className="project-owner">
                <img
                  src={projectOwnerImage}
                  width={24}
                  height={24}
                  className="rounded-circle"
                  title={project.owner_name}
                  alt=""
                />
                <i className="fa-solid fa-circle-check" />
              </div>
              <div ref={projSupporterRef}>
                <ProjectSupporter users={users} project={project} />
              </div>
              <div className="date-time-div">
                <p className="colored-span date-time-text">
                  <i className="fa-regular fa-calendar-days" />
                  <input
                    type="datetime-local"
                    className="date-without-icon"
                    value={new Date(project.date_created)
                      .toISOString()
                      .slice(0, 16)}
                    readOnly
                  />
                </p>
                {adminUser.adminUser && showDeleteBtn && (
                  <i
                    ref={projDeleteRef}
                    className="deleteProjectBtn fa fa-trash"
                    title="Delete Project"
                    onClick={() => setDeletePopup(true)}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {deletePopup && (
        <div className="deletePrj-popup-wrapper">
          <div className="tab-pane fade show deletePrj-div">
            <div>
              <center>
                <img src={errorRedIcon} width="50px" height="50px" alt="" />
                <p>
                  <strong>WARNING!</strong> Project will be permanently removed!
                </p>
                <br />
              </center>
            </div>
            <div>
              <center>
                <button
                  className="btn btn-light"
                  onClick={() => setDeletePopup(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn base-btn"
                  style={{ marginLeft: "6px" }}
                  onClick={handleDelete}
                >
                  Continue
                </button>
              </center>
            </div>
          </div>
        </div>
      )}

      {loadingPopup && (
        <div className="deletePrj-popup-wrapper">
          <div className="tab-pane fade show deletePrj-div">
            <center>
              <p style={{ fontSize: "18px" }}>
                Deleting project. Please wait . . .
              </p>
              <br />
              <img
                src={LoadingIcon}
                alt=""
                style={{ width: "50px", marginRight: "5px" }}
              />
            </center>
          </div>
        </div>
      )}
    </>
  );
}
